module.exports = __webpack_public_path__ + "static/img/fdaf5a3571b28becd2a3.a534fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdaf5a3571b28becd2a3.jpg
// module id = 3unS
// module chunks = 1